/* eslint-disable import/prefer-default-export */
import styled, { keyframes } from 'styled-components';

/* Days Badge Styles */
export const DaysLeftBadgeWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  position: relative;
`;

export const ExpirationDate = styled.div`
  position: absolute;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #fff;
  top: 72px;
`;

export const OuterBadgeWrapper = styled.div`
  background: #cfeaf2;
  border-radius: 133px;
  width: 133px;
  height: 133px;
  display: flex;
  justify-content: center;
`;

export const InnerBadgeWrapper = styled.div`
  background: #00aed9;
  border-radius: 133px;
  width: 123px;
  height: 123px;
  margin: 5px;
  display: flex;
  justify-content: center;
`;

export const DaysAndTextWrapper = styled.div`
  color: #fff;
  width: 100%;
  height: 100%;
  display: block;
  flex-direction: column;
  text-align: center;
  position: relative;
`;

export const DaysContainer = styled.div`
  // margin-top: 19px;
  color: #fff;
  height: 65px;
  height: 100%;
  // margin-bottom: 4px;
  position: relative;
  display: flex;
  justify-content: center;
`;

export const RingForeground = styled.div`
  position: absolute;
  top: calc((65px - 8px) / 2);
  left: calc((123px - 57px) / 2);
  height: 12px;
  display: flex;
  z-index: 3;
  padding-top: 16px;
`;

export const DaysWrapper = styled.div`
  display: flex;
  position: relative;
  z-index: 2;
  height: 65px;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

export const DayColumn = styled.div<{ duration: number }>`
  position: absolute;
  top: 0;
  transition: top ${(props) => props.duration}s;
  transition-timing-function: linear;
`;

export const Day = styled.div`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 72px;
  line-height: 72px;
  padding: 16px 0 39px;
`;

export const RingBackground = styled.div`
  position: absolute;
  top: calc((65px - 8px) / 2 + 9px);
  left: calc((123px - 51px) / 2);
  height: 8px;
  display: flex;
  z-index: 1;
  padding-top: 16px;
`;

const textAnimation = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const DaysTextContainer = styled.div<{ duration: number }>`
  color: #fff;
  height: 16px;
  text-transform: uppercase;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  opacity: 0;
  // animation-name: ${textAnimation};
  // animation-duration: ${(props) => props.duration}s;
  // animation-iteration-count: 1;
  // animation-timing-function: ease-in;
  transition: opacity 1s;
  transition-timing-function: ease-in;
  position: absolute;
  width: 100%;
  bottom: 20px;
`;
